import { V3ArcingAlarmSettings } from 'ngx-modbus';

import { LeanFormSchema, fieldRef } from '../types/config-form.types';

export const ARCING_ALARM_FORM: LeanFormSchema = {
  version: '1',
  id: 'arcing-alarm',
  name: 'Arcing Alarm',
  sections: [{
    id: 'arcing-alarm',
    labelKey: 'arcingAlarmSettings',
    registerTable: 'V3ArcingAlarmSettings',
    validityMask: 'AddressMask_Config_Basic3',
    fields: [
      fieldRef(V3ArcingAlarmSettings, 'ArcingAlarmEnable'),
    ],
  }],
};
